import { FC } from 'react'
import { Link } from 'react-router-dom'

import {
  abbreviate,
  Avatar,
  Ellipsis,
  Item,
  Text,
  VStack,
} from '@revolut-internal/ui-kit'

import { useCreateAgentsRoute } from 'hooks/useCreateAgentsRoute'
import { Security } from 'modules/security/security'
import { getCurrentShiftPosition } from 'pages/Monitoring/agent/AgentAttendanceDetails/utils/getCurrentShiftPosition'
import { AgentAttendanceShort } from 'types'
import { humanize } from 'utils/format'
import { formatDuration } from 'utils/formatTimeAndDuration'

type ResourcesPanelAgentDetailsProps = {
  agentDetails: AgentAttendanceShort
}

export const ResourcesPanelAgentDetails: FC<ResourcesPanelAgentDetailsProps> = ({
  agentDetails,
}) => {
  const createAgentsRoute = useCreateAgentsRoute([agentDetails.agent.id])
  const currentPosition = getCurrentShiftPosition(agentDetails.shift.positions)
  const canViewAgents = Security.canViewAgentAttendance

  return (
    <Item
      use={canViewAgents ? Link : undefined}
      to={canViewAgents ? createAgentsRoute() : undefined}
    >
      <Item.Avatar>
        <Avatar>{abbreviate(agentDetails.agent.name)}</Avatar>
      </Item.Avatar>
      <Item.Content>
        <Item.Title>{agentDetails.agent.name}</Item.Title>
        <Item.Description>
          <VStack>
            <Text>
              {humanize(agentDetails.agent.currentStatus)}{' '}
              {agentDetails.agent.currentStatusDuration
                ? `for ${formatDuration(agentDetails.agent.currentStatusDuration)}`
                : ''}
            </Text>
            {currentPosition.currentPosition && (
              <Ellipsis tooltip="always">{currentPosition.currentPosition.name}</Ellipsis>
            )}
          </VStack>
        </Item.Description>
      </Item.Content>
    </Item>
  )
}
